import styles from './Header.module.scss';
import {PropsWithChildren} from "react";
import {IPageBookmarkProps, PageBookmark} from "../../PageBookmark/PageBookmark";

export type HeaderProps = {
    /** The title of the page. */
    title: string;
} & ({
    /** Should we include the PageBookmark component? */
    includePageBookmark: true;
    /** The status of the PageBookmark component. */
    bookmarked: IPageBookmarkProps['bookmarked'];
    /** The function to call to edit the status of the PageBookmark component. */
    onClick: IPageBookmarkProps['onClick'];
} | {
    /** Should we include the PageBookmark component? */
    includePageBookmark?: false;
});

export const Header = (props: PropsWithChildren<HeaderProps>) => {
    return (
        <div className={styles.mainHeaderContainer}>
            <span className={styles.textAndBookmarkContainer}>
                <span className={styles.titleText}>{props.title}</span>
                {props.includePageBookmark && <PageBookmark bookmarked={props.bookmarked} onClick={props.onClick}/>}
            </span>
            {props.children}
        </div>
    );
}

const LHS = ({children}: PropsWithChildren) => {
    return (
        <span className={styles.leftHeaderSideContainer}>
            {children}
        </span>
    );
};

const RHS = ({children}: PropsWithChildren) => {
    return (
        <span className={styles.rightHeaderSideContainer}>
            {children}
        </span>
    );
};

Header.LHS = LHS;
Header.RHS = RHS;